import { Component } from "@angular/core";
import { Title } from "@angular/platform-browser";

@Component({
    selector: "independent-living-goals-worksheet",
    templateUrl: "./independent-living-goals-worksheet.component.html",
    styleUrls: ["./independent-living-goals-worksheet.component.css"]
})
export class UnitFiveLessonThreeIndependentLivingGoalsWorksheetComponent {

    title: string = "Independent Living Goals Worksheet";
    pageTitle: string = this.title + " | Unit 5, Lesson 3 | T-Folio";

    public constructor(private titleService: Title) {
        this.titleService.setTitle(this.pageTitle);
    }
}
